import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { withApollo } from "react-apollo";
import queryString from "query-string";

import { getAccessPermisionQuery } from "../../services/graphql/queries/accessPermission";
import { getCategoryByIdForProjectFolder } from "../../services/graphql/queries/category-management";

import ReactModal from "../Common/ReactModal";
import NotAccessible from "../Common/NotAccessible";

import { errorMessage } from "../../miscellaneous/error-messages";
import { errorMsg } from "../../miscellaneous/react-toastify";

import { DO_NOT_ACCESS_MESSAGE } from "../../constants/app-constants";

import CategoryView from "./CategoryView";
import CategoryEdit from "./CategoryEdit";
import ProjectFolderDetails from "./ProjectFolderDetails";

const CATEGORY_MODULE_ID = 16;

const CATEGORY_FEATURE_ID = 244;
const CATEGORY_SUBCATEGORY_FEATURE_ID = 201;
const CATEGORY_DOC_UPLOAD_USER_FEATURE_ID = 202;
const CATEGORY_DOC_VIEW_USER_FEATURE_ID = 203;

class CategoryFolderProfile extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      error: "",
      editMode: false,
      category: {},
      reactModalVisible: false,
      requireCancel: false,
      modalMessage: DO_NOT_ACCESS_MESSAGE,
      accessSpecifier: {},
      isCreate: false
    };
    this.toggleEditMode = this.toggleEditMode.bind(this);
    this.onUpdateCategory = this.onUpdateCategory.bind(this);
    this.submitModal = this.submitModal.bind(this);


  }

  submitModal() {
    this.setState({ reactModalVisible: false });
  }

  toggleEditMode(mode) {
    // this.setState({ editMode: !this.state.editMode });
    if (this.state.accessSpecifier[CATEGORY_FEATURE_ID].editP)
      this.setState({ editMode: !this.state.editMode });
    else this.setState({ reactModalVisible: true });
  }

  onUpdateCategory(){
    this.getCategoryById();
  }

  getCategoryById(){
    this.props.client
      .query({
        query: getCategoryByIdForProjectFolder,
        variables: { id: parseInt(queryString.parse(this.props.location.search).id) },
        fetchPolicy: "network-only"
      })
      .then(result => {
        const category = result.data.getCategoryByIdForProjectFolder;

        this.initialState = {
          category: category
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch(error => {
        console.log("~~~error: ", error);
        let message = errorMessage(error);
        errorMsg(message[0]);
        // this.setState({ loading: false, error: error.message });
        this.setState({ loading: false, error: message[0] });
      });
  }

  componentDidMount(){
    let isCreate = (queryString.parse(this.props.location.search).create)
    this.setState({ loading: true, 
      isCreate: isCreate != undefined ? true: false 
    });
    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: CATEGORY_MODULE_ID
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        this.setState({
          accessSpecifier: response
        });
        this.getCategoryById();
      })
      .catch(error => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({
          loading: false,
          error: error.message
        });
      });
  }

  render() {
    const { 
      loading,
      error,
      accessSpecifier, 
      editMode, 
      category, 
      reactModalVisible,
      requireCancel,
      modalMessage,
      isCreate 
    } = this.state;
    if (loading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>{error}</div>;
    }
    return (
      <>
      {accessSpecifier  &&
        accessSpecifier[CATEGORY_FEATURE_ID] && accessSpecifier[CATEGORY_FEATURE_ID].viewP ? (
      <div>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={requireCancel}
        />
        {editMode ? (
            <CategoryEdit
              category={category}
              toggleEditMode={this.toggleEditMode}
              onUpdateCategory={this.onUpdateCategory}
            />
            ) : (
            <CategoryView 
              category={category}              
              toggleEditMode={this.toggleEditMode} 
            />
          )
        }
        {accessSpecifier  &&
        accessSpecifier[CATEGORY_FEATURE_ID] && accessSpecifier[CATEGORY_FEATURE_ID].editP 
        ? <ProjectFolderDetails
            isCreate={isCreate}
            category={category} 
            onUpdateCategory={this.onUpdateCategory}
          />
        : null
        }
        
      </div>
      ) : (
        <NotAccessible />
      )}
      </>
    );
  }
}

CategoryFolderProfile.getInitialProps = ({ router }) => {
  return { router };
};

export default withRouter(connect()(withApollo(CategoryFolderProfile)));
